<template>
    <div class="layout">
        <sidebar/>
        <Menu/>
        <router-view/>
    </div>
</template>

<script>
import Sidebar from '@/components/Sidebar.vue';
import Menu from '@/components/Menu.vue';

export default {
    components: {
        Sidebar,
        Menu,
    },
};
</script>
